import useDetailsBooking from 'hooks/useDetailsBooking';
import usePrintOnMount from 'hooks/usePrintOnMount';
import useTitleOnMount from 'hooks/useTitleOnMount';
import Header from './Header';
import Body from './Body';
import Footer from './Footer';
import { PageContainer, PrintViewPageContainer } from './primitives';

const PrintViewPage = () => {
  const { booking } = useDetailsBooking();

  useTitleOnMount(booking.reference);
  usePrintOnMount();

  return (
    <PageContainer>
      <PrintViewPageContainer>
        <Header bookingRef={booking.reference} />
        <Body booking={booking} />
        <Footer />
      </PrintViewPageContainer>
    </PageContainer>
  );
};

export default PrintViewPage;
